import _once from "lodash/once";
import _isFinite from "lodash/isFinite";
import { GraphicalOutputPlaceholder, TrackerContext } from '@datacamp/campus-integration';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import useSize from 'react-use/lib/useSize';
import { ConnectedVirtualMachine } from '../lib/ConnectedVirtualMachine';
import { jsx as ___EmotionJSX } from "@emotion/react";
const useInitialLayout = layout => {
  const [initialLayout, setInitialLayout] = useState();
  const {
    height,
    width,
    zoom
  } = layout;
  useEffect(() => {
    if (initialLayout == null && _isFinite(width) && _isFinite(height)) {
      setInitialLayout({
        height,
        width,
        zoom
      });
    }
  }, [initialLayout, width, height, zoom]);
  return initialLayout;
};
const MAX_RETRY = 5;
export const GuacamoleClient = _ref => {
  let {
    environment,
    onError,
    onReady,
    sessionId,
    zoom
  } = _ref;
  const {
    tracker
  } = useContext(TrackerContext);
  const containerRef = useRef(null);

  // Add retry logic to avoid showing the error pane because of sizing issue
  const [retry, setRetry] = useState(0);
  const onRetry = useCallback(() => {
    setRetry(retry + 1);
    if (retry > MAX_RETRY) {
      onError(false, new Error('Error in Guacamole after retrying.'));
    }
  }, [onError, retry]);
  const onReadyCb = useCallback(() => {
    setRetry(0);
    onReady();
  }, [onReady]);
  const firstMouseClick = useCallback(_once(tracker.eventUserFirstMouseClick).bind(tracker, sessionId), [tracker, sessionId]);
  const [component, {
    height,
    width
  }] = useSize(() => {
    return ___EmotionJSX("div", {
      className: "dc-u-fx dc-u-wh-100pc dc-u-bgc-grey-400 dc-u-of-auto dc-u-fx-aic dc-u-fx-jcc dc-u-of-hidden",
      ref: containerRef
    }, ___EmotionJSX(GraphicalOutputPlaceholder, {
      className: "dc-u-pos-absolute dc-u-b-none"
    }));
  });
  const initialLayout = useInitialLayout({
    height,
    width,
    zoom
  });
  const [connectedVM, setConnectedVM] = useState();
  useEffect(() => {
    if (containerRef.current !== null && initialLayout != null && _isFinite(initialLayout.width) && _isFinite(initialLayout.height)) {
      const connectedVirtualMachine = new ConnectedVirtualMachine(containerRef.current, onError, onRetry, onReadyCb, firstMouseClick, environment);
      connectedVirtualMachine.connect(sessionId, initialLayout.width, initialLayout.height, initialLayout.zoom);
      setConnectedVM(connectedVirtualMachine);
      return () => connectedVirtualMachine.dispose();
    }
    return () => {
      // nothing to dispose
    };
  }, [onError, onRetry, onReadyCb, environment, sessionId, firstMouseClick, initialLayout]);
  useEffect(() => {
    if (connectedVM != null && _isFinite(zoom)) {
      connectedVM.scale(zoom);
    }
  }, [connectedVM, zoom]);
  useEffect(() => {
    if (connectedVM != null && _isFinite(width) && _isFinite(height)) {
      connectedVM.updateSize(width, height);
    }
  }, [connectedVM, width, height]);
  return component;
};